export default __webpack_public_path__ + "static/media/xciBTC.58131b59.png";